import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import Pagination from "components/Pagination/Pagination";

import ClassificationList from "./ClassificationList";
import EventList from "./EventListDesktop";
import OwnerList from "./OwnerListDesktop";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const Result = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const Group = styled.div`
  min-width: 33%;
  padding: 10px;
`;
const Label = styled.div`
  font-weight: normal;
  font-size: 14px;
  color: #7b848d;
`;
const Data = styled(Label)`
  font-weight: bold;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function FederalSearchResultsDesktop({ federalSearchResults }) {
  const [currentPage, setCurrentPage] = useState(1);

  if (!federalSearchResults) return null;

  const result = federalSearchResults[currentPage - 1];

  return (
    <Container>
      <Title>Federal Search Results</Title>

      {federalSearchResults.length ? (
        <>
          <Result>
            <Group>
              <Label>Serial number</Label>
              <Data>{result.serialNumber}</Data>
            </Group>

            <Group>
              <Label>Registration number</Label>
              <Data>{result.registrationNumber}</Data>
            </Group>

            <Group>
              <Label>Mark Identification</Label>
              <Data>{result.markIdentification}</Data>
            </Group>

            <Group>
              <Label>Status code</Label>
              <Data>{result.statusCode}</Data>
            </Group>

            <Group>
              <Label>Status date</Label>
              <Data>{result.statusDate}</Data>
            </Group>

            <Group>
              <Label>Filing date</Label>
              <Data>{result.filingDate}</Data>
            </Group>

            <Group>
              <Label>Registration date</Label>
              <Data>{result.registrationDate}</Data>
            </Group>

            <Group>
              <Label>Attorney name</Label>
              <Data>{result.attorneyName}</Data>
            </Group>

            <Group>
              <Label>Mark drawing code</Label>
              <Data>{result.markDrawingCode}</Data>
            </Group>

            <ClassificationList classifications={result.classification} />

            <OwnerList owners={result.owners} />

            <Group>
              <Label>Correspondence name</Label>
              <Data>{result.correspondenceName}</Data>
            </Group>

            <Group>
              <Label>Correspondence address</Label>
              <Data>{result.correspondenceAddress1}</Data>
            </Group>

            <Group>
              <Label>Correspondence address 2</Label>
              <Data>{result.correspondenceAddress2}</Data>
            </Group>
            <EventList events={result.events} />
          </Result>
          <Pagination
            bottom
            currentPage={currentPage}
            totalPages={federalSearchResults.length}
            onClick={setCurrentPage}
          />
        </>
      ) : (
        <EmptyMessage>No conflicting Federal search results found</EmptyMessage>
      )}
    </Container>
  );
}

FederalSearchResultsDesktop.propTypes = {
  federalSearchResults: PropTypes.arrayOf(PropTypes.object),
};

export default FederalSearchResultsDesktop;
